import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';

const PAGE_X_AXIS_PADDING_BY_BREAKPOINT = {
    XXSMALL: 15,
    XSMALL: 15,
    SMALL: 35,
    SMALL_FIVE_TIMESLOTS: 24,
    MEDIUM: 42,
    LARGE: 53,
    XLARGE: 60,
    XXLARGE: 60,
};

/**
 * @param {JSX.Element} component
 * @returns {JSX.Element}
 */
class BaseContainer extends PureComponent {
    static defaultProps = {
        component: 'section',
    };

    render() {
        const { component: Component, ...props } = this.props;

        return <Component {...props} />;
    }
}

const PaddedContainer = styled(BaseContainer)`
    box-sizing: border-box;

    padding-left: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.XXSMALL}px;
    padding-right: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.XXSMALL}px;
    position: relative;

    ${breakpoint.xsmall} {
        padding-left: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.XSMALL}px;
        padding-right: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.XSMALL}px;
    }

    ${breakpoint.small} {
        padding-left: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.SMALL}px;
        padding-right: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.SMALL}px;
    }

    ${breakpoint.medium} {
        padding-left: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.MEDIUM}px;
        padding-right: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.MEDIUM}px;
    }

    ${breakpoint.large} {
        padding-left: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.LARGE}px;
        padding-right: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.LARGE}px;
    }

    ${breakpoint.xlarge} {
        padding-left: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.XLARGE}px;
        padding-right: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.XLARGE}px;
    }

    ${breakpoint.xxlarge} {
        padding-left: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.XXLARGE}px;
        padding-right: ${PAGE_X_AXIS_PADDING_BY_BREAKPOINT.XXLARGE}px;
    }
`;

export {
    PaddedContainer as default,
    PaddedContainer,
    PAGE_X_AXIS_PADDING_BY_BREAKPOINT,
};
